import QRCode from "react-qr-code";
import { useState, useEffect } from "react";
let UploadUrl = process.env.REACT_APP_Upload_Image_Url;

let imagePlaceholder = "https://res.cloudinary.com/ebuka1122/image/upload/v1746897856/static%20images%20storelens/download_bvjych.png";

const UploadImageWithPhone = ({ setTakeImageWithPhone, store, socket, setCroppedImageUrl, setCroppedImageBolb, setIsImageUploaded }) => {
  const [image, setImage] = useState([]); /* [] */
  const [imageBuffer, setImageBuffer] = useState([]);

  useEffect(() => {
    socket.on("newImagesFromPhone", ({ storeID, imagesBuffer }) => {
      //  setImage(imageUrl);

      let blobArray = imagesBuffer.map((buffer) => {
        return new Blob([buffer]);
      });
      setImageBuffer(blobArray);
      /* convert each blob to image url */

      let imageUrlArray = blobArray.map((blob) => {
        return URL.createObjectURL(blob);
      });
      setImage(imageUrlArray);
      //  console.log("imageUrl", imageUrl);
    });

    return () => {
      socket.off("newImagesFromPhone");
    };
  }, []);

  const useImages = () => {
    setIsImageUploaded(true);
    setCroppedImageUrl(image);
    setCroppedImageBolb(imageBuffer);
    setTakeImageWithPhone(false);
  };
  return (
    <>
      <div className='uploadImageWithPhone'>
        <div className='QRCodeDIve'>
          <h3>Scan QR Code to take photos</h3>
          <div className='ImageUploadDisplay44'>
            <img src={!image.length == 0 ? image[0] : imagePlaceholder} />
            <img src={image.length > 1 ? image[1] : imagePlaceholder} />
            <img src={image.length > 2 ? image[2] : imagePlaceholder} />
            <img src={image.length > 3 ? image[3] : imagePlaceholder} />
          </div>
          <div>
            {" "}
            <QRCode size={200} value={`${UploadUrl}/${store._id}`} />
          </div>
          {image.length > 0 ? (
            <button onClick={useImages} className='useImageBtn122'>
              Use this images
            </button>
          ) : (
            <button style={{ opacity: "0.7", cursor: "not-allowed" }} className='useImageBtn122'>
              Use this images
            </button>
          )}
          <button onClick={() => setTakeImageWithPhone(false)} className='cancleUse33'>
            Cancel
          </button>
        </div>
      </div>
    </>
  );
};

export default UploadImageWithPhone;
